import i18n from '@/i18n';

export default [
  {
    meta: {
      title: i18n.global.t('page_titles.embedded_chart'),
      requiresAuth: true,
      demo: true,
      hideNewsletter: true,
      hideFooter: true,
      embedded: true,
    },
    path: '/visualization/:visualizationId',
    name: 'embedded-visualization',
    component: () => import('../../features/visualizations/pages/EmbeddedChart.vue'),
  },
  {
    meta: {
      title: i18n.global.t('page_titles.dataset_chart_fullscreen'),
      requiresAuth: true,
      demo: true,
      hideFooter: true,
      fullScreen: true,
    },
    path: '/visualization/:visualizationId/fullscreen',
    name: 'visualization-fullscreen',
    component: () => import('../../features/visualizations/pages/EmbeddedChart.vue'),
  },
  {
    meta: {
      title: i18n.global.t('page_titles.dataset_page'),
      requiresAuth: true,
      demo: true,
      hideNewsletter: true,
      hideFooter: true,
    },
    path: '/dataset/:datasetId',
    name: 'dataset-page',
    component: () => import('../../features/datasets/pages/DatasetPage.vue'),
  },
  // {
  //   meta: {
  //     title: 'Charts'
  //   },
  //   path: '/charts',
  //   name: 'charts',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('../../pages/Charts')
  // },
  // {
  //   meta: {
  //     title: 'Tables & Lists'
  //   },
  //   path: '/tables-and-lists',
  //   name: 'tables-and-lists',
  //   component: () => import('../../pages/TablesLists')
  // },
  // {
  //   meta: {
  //     title: 'Forms'
  //   },
  //   path: '/forms',
  //   name: 'forms',
  //   component: () => import('../../pages/Forms')
  // },
  // {
  //   meta: {
  //     title: 'UI Components'
  //   },
  //   path: '/ui',
  //   name: 'ui',
  //   component: () => import('../../pages/Ui')
  // },
  {
    meta: {
      title: i18n.global.t('page_titles.page_not_found'),
    },
    path: '/page-not-found',
    name: 'missing-page',
    component: () => import('@/pages/page-not-found/PageNotFound'),
  },
  {
    meta: {
      title: i18n.global.t('page_titles.page_not_found'),
    },
    path: '/:pathMatch(.*)*',
    name: 'error',
    redirect: { name: 'missing-page' },
  },
];
